import StorefrontIcon from '@mui/icons-material/Storefront';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ListItem from "../../components/card/listItem/listItem";
import { StoreInfoDropDown } from "../../components/dropDown/storeDropDown/storeInfoDropDown";
import EmptyImage from "../../components/emptyStyles/emptyImage";
import { IBranches } from "../../models/store.model";
import { changeRouteType, getpervInnerState } from "../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../redux/headerTitle/headerTitleSlice";
import { getJwtToken } from "../../services/auth.service";


export default function StoreBranches() {
    const dispatch = useDispatch();
    const { token } = getJwtToken();
    const STOREINFO_STORAGE = "StoreInfo";
    const STOREINFOLOGO_STORAGE = "StoreInfoLogo";
    const storeTitleTemp = sessionStorage.getItem("storeTitle");
    const msg = `لیست شعب فروشگاه "${storeTitleTemp}"`;
    const randomKeyForDispatch = Math.random();

    const [storeInfo, setStoreInfo] = useState<IBranches[] | null>(null);
    const [storeInfoLogo, setStoreInfoLogo] = useState<string | null>(null);


    useEffect(() => {

        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `sellerInfo  ${randomKeyForDispatch}` }));
        dispatch(setHeaderTitle({ header: msg, color: 'var(--header-color)', parentRoute: '', }))


        const storeInfoTemp = sessionStorage.getItem(STOREINFO_STORAGE);
        if (storeInfoTemp != null) {
            setStoreInfo(JSON.parse(storeInfoTemp));
        }
        const storeInfoLogoTemp = sessionStorage.getItem(STOREINFOLOGO_STORAGE);
        if (storeInfoLogoTemp != null) {
            setStoreInfoLogo(storeInfoLogoTemp);
        }


        const handleBeforeUnload = () => {
            sessionStorage.removeItem(STOREINFO_STORAGE);
            sessionStorage.removeItem(STOREINFOLOGO_STORAGE);
        };


        window.addEventListener('beforeunload', handleBeforeUnload);


        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };



    }, []);


    return (
        <>
            <div className={"px-5 h-[80svh] overflow-y-auto "} style={{ paddingTop: "10px" }}>
                {storeInfo &&
                    storeInfo.map((item: IBranches, index: number) => {
                        return (
                            <StoreInfoDropDown
                                storeTitle={storeTitleTemp!}
                                title={item.title}
                                address={item.address}
                                lat={item.lat}
                                lng={item.lng}
                                phones={item.phoneNumbers}
                                logo={item.logoUrl && !item.logoUrl ?
                                    <img style={{ width: "70%", height: "70%", objectFit: "contain", justifySelf: "center" }} src={` ${item?.logoUrl}`} /> : storeInfoLogo ?
                                        <img style={{ width: "70%", height: "70%", objectFit: "contain", justifySelf: "center" }} src={` ${storeInfoLogo}`} /> : <EmptyImage icon={<StorefrontIcon sx={{ color: "#E6E9F4" }} />
                                        } />
                                }
                                key={index}
                                element=
                                {<ListItem titleCenter={true} onClick={() => { }} title={item.title} id={index} isShown={false}
                                    icon={storeInfoLogo ?
                                        <div style={{ height: "10svh", display: "flex", alignItems: "center" }}>
                                            <img src={` ${storeInfoLogo}`} style={{ height: "80%" }} />
                                        </div> : <EmptyImage icon={<StorefrontIcon sx={{ color: "#E6E9F4" }} />
                                        } />
                                    } />}
                            />
                        )
                    })
                }
            </div >
        </>
    )
}